export enum RefThirdPartyStatus {
    Active = "fba424d5-3e03-48f9-80a5-97edfa469ddd",
    Inactive = "cf3aa8ea-5425-4838-a059-60d8ba462227",
    Pending = "bf6b465f-49ec-46db-8e5d-24265773f2cc",
    Deleted = "ab7f02e8-d4ac-4e03-8311-9ed7f54ea35a",
  }